module.exports = __webpack_public_path__ + "media/luxury-2026/mianus-architecture-960-c2ffff41.jpg";